module.exports = __webpack_public_path__ + "static/p_jenn-c-9917ee23d4037c782bea39ac5c1822ee.jpg";